/* =============================================================================
   OPTIMIZED: Ajax Add to Cart + Mini Cart Drawer (Faster Performance)
============================================================================= */

if (typeof ShopifyAPI === 'undefined') { ShopifyAPI = {}; }

/* =============================================================================
   SHOPIFY API HELPERS (cache-busted getCart)
============================================================================= */
function attributeToString(attribute) {
  if (typeof attribute !== 'string') {
    attribute += '';
    if (attribute === 'undefined') attribute = '';
  }
  return jQuery.trim(attribute);
}

ShopifyAPI.onCartUpdate = function (cart) {};

ShopifyAPI.updateCartNote = function (note, callback) {
  jQuery.ajax({
    type: 'POST', url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function (cart) {
      if (typeof callback === 'function') callback(cart);
      else ShopifyAPI.onCartUpdate(cart);
    },
    error: function (xhr, status) { ShopifyAPI.onError(xhr, status); }
  });
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  jQuery.ajax({
    type: 'POST', url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function (line_item) {
      if (typeof callback === 'function') callback(line_item, form);
      else ShopifyAPI.onItemAdded(line_item, form);
    },
    error: function (xhr, status) {
      if (typeof errorCallback === 'function') errorCallback(xhr, status);
      else ShopifyAPI.onError(xhr, status);
    }
  });
};

/* UPDATED: cache-buster to reduce intermittent stale cart on iOS */
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON('/cart.js', { _: Date.now() }, function (cart) {
    if (typeof callback === 'function') callback(cart);
    else ShopifyAPI.onCartUpdate(cart);
  });
};

ShopifyAPI.changeItem = function (line, quantity, callback) {
  jQuery.ajax({
    type: 'POST', url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function (cart) {
      if (typeof callback === 'function') callback(cart);
      else ShopifyAPI.onCartUpdate(cart);
    },
    error: function (xhr, status) { ShopifyAPI.onError(xhr, status); }
  });
};

/* =============================================================================
   MINI CART DRAWER - OPTIMIZED FOR SPEED + retries
============================================================================= */
;(function ($) {
  'use strict';

  var DRAWER    = '.js-minicart';
  var CONTAINER = '.mini-cart-bottom.enj-minicart-ajax';
  var COUNT     = '.enj-cartcount';
  var BG        = '.js-bg.bg-minicart';

  var $drawer, $container, $count, $bg;

  $(function() {
    $drawer    = $(DRAWER);
    $container = $(CONTAINER);
    $count     = $(COUNT);
    $bg        = $(BG);
  });

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (m) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;' }[m]);
    });
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var fmt = (window.theme && (theme.moneyFormat || theme.money_format))
               || Shopify.money_format || '$';
        return Shopify.formatMoney(cents || 0, fmt);
      }
    } catch (e) {}
    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function imgSmall(url) {
    if (!url) return '';
    return String(url).replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
  }

  function openDrawer() {
    if (!$drawer) $drawer = $(DRAWER);
    if (!$bg) $bg = $(BG);
    $drawer.addClass('active');
    $bg.addClass('active');
    $('body').css('overflow', 'hidden');
  }

  function closeDrawer() {
    if (!$drawer) $drawer = $(DRAWER);
    if (!$bg) $bg = $(BG);
    $drawer.removeClass('active');
    $bg.removeClass('active');
    $('body').css('overflow', '');
  }

  function showLoading() {
    if (!$container) $container = $(CONTAINER);
    if (!$container.length) return;

    $container.html(
      '<div class="mc-loading" style="display:flex;align-items:center;justify-content:center;padding:60px 20px;">' +
        '<div style="text-align:center;">' +
          '<div style="width:40px;height:40px;margin:0 auto 12px;border:3px solid #f3f3f3;border-top:3px solid #111;border-radius:50%;animation:spin 0.8s linear infinite;"></div>' +
          '<p style="color:#888;font-size:13px;margin:0;">Loading cart...</p>' +
        '</div>' +
      '</div>' +
      '<style>@keyframes spin{to{transform:rotate(360deg)}}</style>'
    );
  }

  function renderDrawer(cart) {
    if (!$container) $container = $(CONTAINER);
    if (!$container.length) return;
    if (!$count) $count = $(COUNT);

    $count.text(cart.item_count || 0);

    if (!cart.item_count) {
      $container.html(
        '<div class="list_product_minicart empty">' +
          '<div class="empty-product_minicart">' +
            '<p class="mb-4">Your cart is currently empty.</p>' +
            '<a href="/collections/all" class="to-cart btn">Shop now</a>' +
          '</div>' +
        '</div>'
      );
      return;
    }

//     var html = '<div class="prod"><div class="product-cart">';

//     (cart.items || []).forEach(function (item, idx) {
//       var line    = idx + 1;
//       var title   = esc(item.product_title || item.title);
//       var url     = item.url || '#';
//       var img     = item.image ? imgSmall(item.image) : '';
//       // var variant = (item.variant_title && item.variant_title !== 'Default Title')
//       //   ? '<div class="product_variant_mini">' + esc(item.variant_title) + '</div>' : '';
// var variant = (item.variant_title && item.variant_title !== 'Default Title')
//   ? '<div class="product_variant_mini 34">' + esc(item.variant_title) + '</div>'
//   : '';
//       html +=
//         '<ol class="minicart_item list-unstyled mb-0 px-0" data-line="' + line + '">' +
//           '<li class="d-flex">' +
//             '<div class="thumb_img_cartmini">' +
//               '<a href="' + url + '">' + (img ? '<img alt="' + title + '" src="' + img + '">' : '') + '</a>' +
//             '</div>' +
//             '<div class="product-detail">' +
//               '<h3 class="product_name_mini"><a href="' + url + '">' + title + '</a></h3>' +
//               variant +
//               '<div class="product_info">' +
//                 '<div class="mc-qty-stepper">' +
//                   '<button class="mc-qty-btn mc-qty-minus" data-line="' + line + '" type="button">&#8722;</button>' +
//                   '<input class="mc-qty-num" type="number" value="' + item.quantity + '" min="0" data-line="' + line + '">' +
//                   '<button class="mc-qty-btn mc-qty-plus" data-line="' + line + '" type="button">&#43;</button>' +
//                 '</div>' +
//                 '<div class="product_price"><span class="price_sale">' + money(item.price) + '</span></div>' +
//               '</div>' +
//             '</div>' +
//             '<div class="produc_remove">' +
//               '<a href="javascript:void(0)" class="mc-remove-product" data-line="' + line + '">' +
//                 '<i class="fa fa-trash-o"></i>' +
//               '</a>' +
//             '</div>' +
//           '</li>' +
//         '</ol>';
//     });
var html = '<div class="prod"><div class="product-cart">';

(cart.items || []).forEach(function (item, idx) {

  var line  = idx + 1;
  var title = esc(item.product_title || item.title);
  var url   = item.url || '#';
  var img   = item.image ? imgSmall(item.image) : '';

 // Variant
var variant = '';

if (item.variant_title && item.variant_title !== 'Default Title') {
  // variant =
  //   '<div style="font-size:13px; line-height:20px; color:#666; margin:2px 0;">' +
  //     '<strong style="color:#b8aa83; font-weight:600;">Color:</strong> ' +
  //     esc(item.variant_title) +
  //   '</div>';
}


// Line Item Properties
var properties = '';

if (item.properties) {

  Object.keys(item.properties).forEach(function(key) {

    var value = item.properties[key];

    if (
      value !== null &&
      value !== undefined &&
      value !== '' &&
      key.charAt(0) !== '_'
    ) {

      properties +=
        '<div style="font-size:13px; line-height:20px; color:#666; margin:2px 0;   text-align: left;">' +
          '<strong style="color:#b8aa83; font-weight:600;">' +
            esc(key) + ':' +
          '</strong> ' +
          '<span style="color:#666;">' +
            esc(String(value)) +
          '</span>' +
        '</div>';
    }

  });

}

  html +=
    '<ol class="minicart_item list-unstyled mb-0 px-0" data-line="' + line + '">' +
      '<li class="d-flex">' +

        '<div class="thumb_img_cartmini">' +
          '<a href="' + url + '">' +
            (img ? '<img alt="' + title + '" src="' + img + '">' : '') +
          '</a>' +
        '</div>' +

        '<div class="product-detail">' +

          '<h3 class="product_name_mini">' +
            '<a href="' + url + '">' + title + '</a>' +
          '</h3>' +

          variant +

          properties +

          '<div class="product_info">' +

            '<div class="mc-qty-stepper">' +
              '<button class="mc-qty-btn mc-qty-minus" data-line="' + line + '" type="button">&#8722;</button>' +
              '<input class="mc-qty-num" type="number" value="' + item.quantity + '" min="0" data-line="' + line + '">' +
              '<button class="mc-qty-btn mc-qty-plus" data-line="' + line + '" type="button">&#43;</button>' +
            '</div>' +

            '<div class="product_price">' +
              '<span class="price_sale">' + money(item.price) + '</span>' +
            '</div>' +

          '</div>' +

        '</div>' +

        '<div class="produc_remove">' +
          '<a href="javascript:void(0)" class="mc-remove-product" data-line="' + line + '">' +
            '<i class="fa fa-trash-o"></i>' +
          '</a>' +
        '</div>' +

      '</li>' +
    '</ol>';
});
    html += '</div></div>';

    var isRtl   = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
    var actions = isRtl
      ? '<a href="/checkout" class="button-checkout"><span>Checkout</span></a><a href="/cart" class="button-viewcart"><span>View cart</span></a>'
      : '<a href="/cart" class="button-viewcart"><span>View cart</span></a><a href="/checkout" class="button-checkout"><span>Checkout</span></a>';

    html +=
      '<div class="sub-total"><span class="total-title">Total</span><span class="total-price">' + money(cart.total_price) + '</span></div>' +
      '<div class="action-checkout">' + actions + '</div>';

    $container.html(html);
  }

  function getCartWithRetry(tries, done, fail) {
    tries = (typeof tries === 'number') ? tries : 2;

    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      cache: false,
      data: { _: Date.now() },
      timeout: 12000,
      success: done,
      error: function () {
        if (tries <= 0) return fail && fail();
        setTimeout(function () {
          getCartWithRetry(tries - 1, done, fail);
        }, 300);
      }
    });
  }

  function refreshAndRender(callback) {
    getCartWithRetry(2, function (cart) {
      renderDrawer(cart);
      if (typeof callback === 'function') callback(cart);
    }, function () {
      // Last resort: keep UI non-empty and let user continue; next open will refresh again
      if (!$container) $container = $(CONTAINER);
      if ($container && $container.length) {
        $container.html(
          '<div style="padding:18px 24px;color:#888;font-size:13px;">' +
            'Unable to load cart. <a href="javascript:void(0)" class="mc-try-again" style="color:#111;text-decoration:underline;">Try again</a>' +
          '</div>'
        );
      }
    });
  }

  $(document).on('click', '.mc-try-again', function(e){
    e.preventDefault();
    showLoading();
    refreshAndRender();
  });

  function updateLine(line, qty) {
    if (!$container) $container = $(CONTAINER);
    if (!$count) $count = $(COUNT);

    var $row = $container.find('.minicart_item[data-line="' + line + '"]');
    $row.css({ opacity: 0.5, pointerEvents: 'none' });

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: line, quantity: qty },
      dataType: 'json',
      timeout: 12000,
      success: function (cart) {
        renderDrawer(cart);
        $count.text(cart.item_count || 0);
      },
      error: function (xhr) {
        $row.css({ opacity: 1, pointerEvents: '' });
        var resp = {};
        try { resp = JSON.parse(xhr.responseText); } catch (e) {}
        console.warn('Cart error:', resp.description || xhr.responseText);

        // Recover by doing a fresh cart fetch
        refreshAndRender();
      }
    });
  }

  /* XHR intercept */
  (function () {
    var OriginalXHR = window.XMLHttpRequest;

    function PatchedXHR() {
      var xhr      = new OriginalXHR();
      var _method  = '';
      var _url     = '';

      var _origOpen = xhr.open.bind(xhr);
      xhr.open = function (method, url) {
        _method = (method || '').toUpperCase();
        _url    = url || '';
        return _origOpen.apply(xhr, arguments);
      };

      var _origSend = xhr.send.bind(xhr);
      xhr.send = function () {
        xhr.addEventListener('load', function () {
          if (_method === 'POST' && _url.indexOf('/cart/add') !== -1 && xhr.status >= 200 && xhr.status < 300) {
            openDrawer();
            showLoading();
            refreshAndRender();
          }
        });
        return _origSend.apply(xhr, arguments);
      };

      return xhr;
    }

    PatchedXHR.prototype         = OriginalXHR.prototype;
    PatchedXHR.UNSENT            = OriginalXHR.UNSENT;
    PatchedXHR.OPENED            = OriginalXHR.OPENED;
    PatchedXHR.HEADERS_RECEIVED  = OriginalXHR.HEADERS_RECEIVED;
    PatchedXHR.LOADING           = OriginalXHR.LOADING;
    PatchedXHR.DONE              = OriginalXHR.DONE;

    window.XMLHttpRequest = PatchedXHR;
  })();

  /* fetch intercept */
  if (window.fetch) {
    var _originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url    = (typeof input === 'string') ? input : (input.url || '');
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();

      return _originalFetch(input, init).then(function (response) {
        if (method === 'POST' && url.indexOf('/cart/add') !== -1 && response.ok) {
          openDrawer();
          showLoading();
          refreshAndRender();
        }
        return response;
      });
    };
  }

  /* Drawer events */
  $(document).on('click', '.close-mini-cart', closeDrawer);
  $(document).on('click', BG, closeDrawer);

  $(document).on('click', '.overlay-addcart, .continue-shopping, .close-window', function () {
    $('.engo-popup').removeClass('active');
    setTimeout(function(){ refreshAndRender(); }, 50);
  });

  // Remove
  $(document).on('click', CONTAINER + ' .mc-remove-product', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var line = parseInt($(this).data('line'), 10);
    if (!line || isNaN(line)) return;
    updateLine(line, 0);
  });

  // Qty minus
  $(document).on('click', CONTAINER + ' .mc-qty-minus', function (e) {
    e.preventDefault();
    var line   = parseInt($(this).data('line'), 10);
    var $input = $(CONTAINER + ' input.mc-qty-num[data-line="' + line + '"]');
    var qty    = Math.max(0, (parseInt($input.val(), 10) || 1) - 1);
    $input.val(qty);
    updateLine(line, qty);
  });

  // Qty plus
  $(document).on('click', CONTAINER + ' .mc-qty-plus', function (e) {
    e.preventDefault();
    var line   = parseInt($(this).data('line'), 10);
    var $input = $(CONTAINER + ' input.mc-qty-num[data-line="' + line + '"]');
    var qty    = (parseInt($input.val(), 10) || 1) + 1;
    $input.val(qty);
    updateLine(line, qty);
  });

  // Qty direct input
  $(document).on('change', CONTAINER + ' input.mc-qty-num', function () {
    var line = parseInt($(this).data('line'), 10);
    var qty  = Math.max(0, parseInt($(this).val(), 10) || 0);
    $(this).val(qty);
    updateLine(line, qty);
  });

  // Refresh when drawer becomes active (observer after DOM ready)
  $(function(){
    var drawerEl = document.querySelector(DRAWER);
    if (drawerEl && window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.attributeName === 'class' && drawerEl.classList.contains('active')) {
            refreshAndRender();
          }
        });
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  });

  window.openMiniCart    = openDrawer;
  window.closeMiniCart   = closeDrawer;
  window.refreshMiniCart = function () { refreshAndRender(); };

})(jQuery);


/* =============================================================================
   AJAX CART MODULE (legacy) — preserved but made safe
============================================================================= */
var ajaxCart = (function (module, $) {
  'use strict';

  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback,
      cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback,
      createQtySelectors, qtySelectors, validateQty;

  init = function (options) {
    settings = {
      formSelector:       'form[action^="/cart/add"]',

      /* IMPORTANT:
         render into the drawer BODY, not the whole drawer wrapper */
      cartContainer:      '#CartContainer .mini-cart-bottom.enj-minicart-ajax',

      addToCartSelector:  '.enj-add-to-cart-btn',
      cartCountSelector:  null,
      cartCostSelector:   null,
      moneyFormat:        '$',
      disableAjaxCart:    false,
      enableQtySelectors: true
    };

    $.extend(settings, options);

    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body              = $('body');
    isUpdating         = false;

    if (settings.enableQtySelectors) qtySelectors();
    if (!settings.disableAjaxCart && $addToCart.length) formOverride();
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $('.product-popup').find('.product-item-count').html(cart.item_count);
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.js-number-cart').removeClass('active');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find('i').replaceWith(
        '<i class="enj-loader-add-to-cart fsz-unset">' +
          '<svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top:-1px;" viewBox="0 0 24 30" height="20px" width="21px" xmlns="http://www.w3.org/2000/svg">' +
            '<rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2;1;.2" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10;20;10" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10;5;10" attributeName="y"/></rect>' +
            '<rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8"><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2;1;.2" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10;20;10" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10;5;10" attributeName="y"/></rect>' +
            '<rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2;1;.2" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10;20;10" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10;5;10" attributeName="y"/></rect>' +
          '</svg>' +
        '</i>'
      );
      $('.qty-error').remove();
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve">' +
        '<g transform="matrix(1.3333333,0,0,-1.3333333,0,400)"><g transform="scale(0.1)">' +
          '<path style="fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/>' +
        '</g></g>' +
      '</svg>'
    );
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    $addToCart.find('.enj-loader-add-to-cart').remove();
    if (!!data.message && data.status == 422) {
      $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
    }
  };

  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // always re-find container in case drawer markup was re-rendered
    $cartContainer = $(settings.cartContainer);
    $cartContainer.empty();

    if (cart.item_count === 0) {
      $cartContainer.append(
        '<p>' + "Your cart is currently empty." + '</p>' +
        '<a href="/collections/all" class="to-cart btn" style="background:black;color:white;padding:10px 15px;">Shop now</a>'
      );
      cartCallback(cart);
      $('.js-number-cart').removeClass('active');
      return;
    }

    var items = [], item = {}, data = {};
    var source = $('#CartTemplate').html();
    var template;

    try {
      template = Handlebars.compile(source);
    } catch (e) {
      console.error('Handlebars CartTemplate compile failed:', e);

      // fallback to JSON drawer renderer so it still fills
      if (window.refreshMiniCart) window.refreshMiniCart();

      $cartContainer.html('<div style="padding:16px;color:#888;font-size:13px;">Updating cart…</div>');
      cartCallback(cart);
      return;
    }

    $.each(cart.items, function (index, cartItem) {
      var prodImg = cartItem.image
        ? cartItem.image.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '')
        : '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';

      item = {
        id:         cartItem.variant_id,
        line:       index + 1,
        url:        cartItem.url,
        img:        prodImg,
        name:       cartItem.product_title,
        variation:  cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd:    cartItem.quantity + 1,
        itemMinus:  cartItem.quantity - 1,
        itemQty:    cartItem.quantity,
        price:      Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor:     cartItem.vendor
      };
      items.push(item);
    });

    data = {
      items:      items,
      note:       cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    };

    $('.product-popup').find('.product-total-cart')
      .html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));
    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function (cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      var $el  = $(this),
          line = $el.data('line'),
          $qty = $el.siblings('.ajaxcart__qty-num'),
          qty  = validateQty(parseInt($qty.val().replace(/\D/g, ''), 10));

      qty = $el.hasClass('ajaxcart__qty--plus') ? qty + 1 : Math.max(0, qty - 1);
      if (line) updateQuantity(line, qty);
      else $qty.val(qty);
    });

    $body.on('click', '.remove-product', function () {
      var $el  = $(this),
          line = $el.data('line');
      if (line) updateQuantity(line, 0);
    });

    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) evt.preventDefault();
    });

    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () { $el.select(); }, 50);
    });

    $body.on('change', 'textarea[name="note"]', function () {
      ShopifyAPI.updateCartNote($(this).val(), function () {});
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) $row.parent().addClass('is-removed');
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;
    updateCountPrice(cart);
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 150);
  };

  createQtySelectors = function () {
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el        = $(this),
            currentQty = $el.val(),
            itemAdd    = currentQty + 1,
            itemMinus  = currentQty - 1,
            itemQty    = currentQty;

        var source = $('#AjaxQty').html();
        var template;
        try {
          template = Handlebars.compile(source);
        } catch (e) {
          console.error('Handlebars AjaxQty compile failed:', e);
          return;
        }

        var data = { id: $el.data('id'), itemQty: itemQty, itemAdd: itemAdd, itemMinus: itemMinus };
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    var numInputs = $('input[type="number"]');
    if (numInputs.length) {
      numInputs.each(function () {
        var $el        = $(this),
            currentQty = $el.val(),
            inputName  = $el.attr('name'),
            inputId    = $el.attr('id');

        var source = $('#JsQty').html();
        var template;
        try {
          template = Handlebars.compile(source);
        } catch (e) {
          console.error('Handlebars JsQty compile failed:', e);
          return;
        }

        var data = {
          id:        $el.data('id'),
          itemQty:   currentQty,
          itemAdd:   currentQty + 1,
          itemMinus: currentQty - 1,
          inputName: inputName,
          inputId:   inputId
        };

        $el.after(template(data)).remove();
      });

      $('.js-qty__adjust').on('click', function () {
        var $el  = $(this),
            $qty = $el.siblings('.js-qty__num'),
            qty  = validateQty(parseInt($qty.val().replace(/\D/g, ''), 10));

        qty = $el.hasClass('js-qty__adjust--plus') ? qty + 1 : Math.max(1, qty - 1);
        $qty.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    return (parseFloat(qty) == parseInt(qty, 10) && !isNaN(qty)) ? qty : 1;
  };

  module = { init: init, load: loadCart };
  return module;

}(ajaxCart || {}, jQuery));